import uiTheme from "./ui.json";
import { DEV_LST_BACKEND_PROXY_PATH } from "./devProxyPrefix";
import { THEME_PRESETS, THEME_STORAGE_KEY, DEFAULT_THEME_ID, getPresetById, getStoredThemeId } from "./themePresets";
export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? "1.0.0";
export const UI_THEME = uiTheme;
export { THEME_PRESETS, THEME_STORAGE_KEY, DEFAULT_THEME_ID, getStoredThemeId };
export function applyUiTheme() {
    const root = document.documentElement;
    const base = uiTheme?.cssVars;
    if (base && typeof base === "object") {
        Object.entries(base).forEach(([k, v]) => {
            if (typeof v === "string")
                root.style.setProperty(k, v);
        });
    }
    const id = getStoredThemeId();
    const preset = getPresetById(id);
    const extra = preset?.cssVars;
    if (extra && typeof extra === "object") {
        Object.entries(extra).forEach(([k, v]) => {
            if (typeof v === "string")
                root.style.setProperty(k, v);
        });
    }
}
export function setUiThemePreset(themeId) {
    const preset = getPresetById(themeId);
    try {
        localStorage.setItem(THEME_STORAGE_KEY, preset.id);
    }
    catch (e) {
    }
    applyUiTheme();
}
/** 默认 LST 网关；多平台切换时实际域名由 utils/apiPlatform 决定 */
export const LST_API_BASE = import.meta.env.VITE_LST_API_BASE ?? "https://yst-api-public.zjcaee.com";
export const CDN_IMG_BASE = import.meta.env.VITE_CDN_IMG_BASE ?? "https://yst-file.zjcaee.com";
/**
 * 本地 `npm run dev` 调试：为 true 时请求走 `DEV_LST_BACKEND_PROXY_PATH`，由 Vite 代理到 `http://yeguanshanhai.com:3900`（浏览器同源，避免直连跨域被 CORS 拦截）。
 * 为 false 时开发环境直连本机 `http://127.0.0.1:3900`。
 */
export const isLocalDebug = true;

/** 生产：与 nginx.conf 443 中 `location /lst-node/` 一致（无端口 https，便于微信小程序）；旧 :3901 仍可由 Nginx 保留兼容老客户端。 */
function resolveServiceBaseUrl() {
    const fromEnv = import.meta.env.VITE_SERVICE_BASE_URL;
    if (fromEnv)
        return String(fromEnv).replace(/\/$/, "");
    if (import.meta.env.DEV) {
        if (isLocalDebug)
            return DEV_LST_BACKEND_PROXY_PATH;
        return "http://127.0.0.1:3900";
    }
    return "https://yeguanshanhai.com/lst-node";
}
export const SERVICE_BASE_URL = resolveServiceBaseUrl();
